import _ from 'lodash'
import api, { formCfg } from './api'

const temporaryFile = {
  upload(file, uploadProgressCallback, params, context) {
    const cfg = _.merge(formCfg(params, context), {
      timeout: 120 * 1000,
      onUploadProgress: uploadProgressCallback,
    })
    const data = new FormData()
    data.append('file', file)

    return api
      .post('/api/gis_regions/temporary_file/', data, cfg)
      .then((response) => dehydrate(response.data))
  },
}

export function dehydrate({ pk, file, name, extension, thumbnail }) {
  return {
    pk,
    file,
    name,
    extension,
    thumbnail,
  }
}

export default temporaryFile
